import { memo } from "react";
import { IconProps, defaultIconProps } from "./icon.props.type";
import KeyboardArrowRightRoundedIcon from "@mui/icons-material/KeyboardArrowRightRounded";
import { ThemeProvider, createTheme } from "@mui/material";

const ChevronRight = ({
  color = defaultIconProps.color,
  size = defaultIconProps.size,
}: IconProps) => {
  const theme = createTheme({
    palette: { primary: { main: color } },
  });

  return (
    <ThemeProvider theme={theme}>
      <KeyboardArrowRightRoundedIcon
        style={{ width: size, height: size }}
        color="primary"
      />
    </ThemeProvider>
  );
};

export default memo(ChevronRight);
